<template>
  <div class="page-container">
   
    <div class="well">
       
      <div class="level">
          <div v-if="poData.isReceived == 1" class="level-left">
            <h1>Purchase Order #{{ poData.poNumber }} - Received - {{poData.purchasingAgent}}</h1>
          </div>
          <div v-else-if="!userIsCreator" class="level-left">
            <h1>View Purchase Order #{{ poData.poNumber }} - {{poData.purchasingAgent}}</h1>
          </div>
          <div v-else class="level-left">
            <h1 class="no-print">Edit or Mark&nbsp</h1><h1>Purchase Order&nbsp</h1><h1 class="no-print">Received&nbsp</h1><h1>#{{ poData.poNumber }} - {{poData.purchasingAgent}}</h1>
          </div>
           <div class="level-right">
            <button class="button is-medium is-info no-print" @click="printPage">Print</button>
          </div>
      </div>
      <div v-if="poData.isReceived == 1">
        <h2>Received by {{poData.receivedBy}}</h2>
      </div>
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
   
      <po-form 
        :formData="poData"
        ref="poForm" 
        :editing="editing" 
        :receiving="receiving"
        :receivedAll="isReceivedAll"
        :salesContact="salesContact"
        :vendorOptions="vendorOptions">
      </po-form>
      <div class="level no-print">
          <h1>Documents</h1>
      </div>
      <po-documents class="no-print" :documents="documents"></po-documents>
      <button v-if="!(poData.isReceived == 1)" class="button is-info is-fullwidth no-print" @click="openUploader">
        Upload Documents
      </button>
      <b-modal :active.sync="isComponentModalActive" has-modal-card>
          <document-uploader 
            :dropFiles="dropFiles" 
            :recordID="poData.recordID" 
            :docPortal="documents"
            :purchaseOrderID="poData.__kptID"
            @load-data="delayedRefresh"
            ref="cardWindow">
          </document-uploader>
      </b-modal>
      <div class="level">
        <b-field grouped>
          <h1>Items</h1>
        </b-field>
      </div>
              <!--:allValid="allItemsValid"-->
      <po-lines 
        :data=this.lineData 
        :editing="editing" 
        :receiving="receiving" 
        :receivedAll="isReceivedAll"
        ref=poItems
        @clicked-remove-line-item="removeLineItem">
                <!--@receive-line-item="receiveLineItem">-->
      </po-lines>
      <div class="button-bar no-print">
        <button v-if="!(poData.isReceived == 1)" class="button is-medium is-primary is-pulled-left" @click="cancel">Cancel</button>
        <!--<button v-if="!isReceivedAll && hasLineItems" class="button is-medium is-success is-pulled-right" @click="updateRecord(true)" style="margin-bottom: 10px">Overide As Received</button>-->
        <button v-if="!(poData.isReceived == 1)" class="button is-medium is-success is-pulled-right" style="margin: 0px 10px 10px 0px" @click="updateRecord()">Update</button>
        <b-notification class="no-print" type="is-primary" :active.sync="notification" @close="notifictation = false">
          Please add a note as to why not all items have been received.
        </b-notification>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
import store from '../../store/store.js';
import PurchaseOrderForm from './PurchaseOrderForm';
import PurchaseOrderLines from './PurchaseOrderLines';
import PurchaseOrderDocuments from './PurchaseOrderDocuments';
import DocumentUploaderCard from './DocumentUploaderCard';

const DEPARTMENT = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::department';
const QTY_REC = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qtyReceived';
const DESCRIPTION = 'menu__PURCHASE_ORDER_LINE_ITEM__cart_srt::description';
const TRACKING_NUMBER = 'menu__FINANCE_TRACKING_NUMBER__isActive__srt::name';
const QTY_ORDERED = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty';

export default {
  name: 'PurchaseOrderReceivePage',
  components: {  
    'po-form': PurchaseOrderForm,
    'po-lines': PurchaseOrderLines,
    'po-documents': PurchaseOrderDocuments,
    'document-uploader': DocumentUploaderCard
  },
  props:['id'],
  data () {
    return {
      poData: {},
      lineData: [],
      documents: [],
      removedLineData: [],
      isLoading: false,
      isFullPage: true,
      notification: false,
      response: null,
      dropFiles: [],
      isComponentModalActive: false,
      postCount: 0,
      vendorOptions: [],
      salesContact: {
        name: "",
        cell: "",
        phone: "",
        fax: "",
        email: ""
      }
    };
  },
  computed:{
    ...mapState([
      'userInfo',
      'departmentValueList',
      'vendorValueList',
      'purchasingAgentValueList',
      'lineItemDescriptionValueList',
      'trackingNumberValueList',
      'currentPage',
      'salesContactLookup'
    ]),
    // Query for finding chosen purchase order
    searchQuery: function(){
      var searchQuery = {
          // "query": [{
          //     "poNumber": this.id
          // }]
          "query": [{
                "__kptID": this.id
          }]
      };
      return searchQuery;
    },

    // Returns true if ALL items have a quantity received filled in that equals
    // the quantity ordered
    isReceivedAll: function(){
      if(this.lineData.length > 0){
        return this.lineData.every(function(lineItem){
          if(lineItem[QTY_REC] && lineItem[QTY_ORDERED]){
            return lineItem[QTY_REC] == lineItem[QTY_ORDERED];
          }
        }) //|| (this.poData.isReceived == 1);
      }
      return false || (this.poData.isReceived == 1);
    },
    
    // Returns true if ANY items have a quantity received filled in
    isReceivedPartially: function(){
      return this.lineData.some(function(lineItem){
        return lineItem[QTY_REC];
      });
    },
    
    // Returns true if ANY items have "Planer Mill" chosen for department
    includesPlanerDepartment: function(){
      return this.lineData.some(function(lineItem){
        return lineItem[DEPARTMENT] === 'Planer Mill';
      });
    },

    // Returns true if the PO hasn't had an item marked as received yet
    editing: function(){
      return !this.isReceivedPartially && !this.isReceivedAll && this.userIsCreator && !(this.poData.isReceived == 1);
    },
    
    // Returns true after the first item of the PO is marked as received
    receiving: function(){
      return this.isReceivedAll || this.isReceivedPartially;
    },
    hasLineItems: function(){
      return this.lineData.length > 0; 
    },
    // Returns true if the currently logged in user is the user who created the PO
    userIsCreator: function(){
      return this.userInfo.employeeName == this.poData.purchasingAgent;
    }
  },
  created:function(){
    // this.isLoading = true;
    this.loadValueLists();
  },
  // Loads the purchase order when mounted
  mounted:function(){
    // this.isLoading = true;
    this.loadData();
  },
  methods:{
    ...mapMutations([
      'updateSalesContactLookup',
      'updateDepartmentValueList',
      'updateVendorValueList',
      'updatePurchasingAgentValueList',
      'updateLineItemDescriptionValueList',
      'updateTrackingNumberValueList',
      'updateTrackingNumberOptions',
      'updateCurrentPage'
    ]),
    /*
    | Compares the number of emits from child to number of documents to upload
    | reloads data if all the posts have completed and closes the card window
    */
    delayedRefresh: function(){
      this.postCount++;
      if(this.postCount == this.dropFiles.length){
        this.updateRecord();
        this.postCount = 0;
        this.$refs.cardWindow.closeWindow();
        this.$refs.cardWindow.isLoading = false;
      }
    },
    // Loads purchase order from FM
    loadData: function(){
      this.isLoading = true;
      var self = this;
      var poForm = this.$refs.poForm;

      // Clear out portal data
      self.documents = [];
      self.lineData  = [];
     
      this.$http.post('api/v2/find.php?layout=purchaseOrder-dataEntry', this.searchQuery)
      .then( response => {
        // console.log(JSON.parse(response.data.split('\n')[response.data.split('\n').length - 1]))
        // if (window.location.href.includes('localhost')) {
        //   response.data = JSON.parse(response.data.split('\n')[response.data.split('\n').length - 1])
        // }
        if(response.data.messages[0].code === "401"){
          this.$toast.open(response.data.messages[0].message);
          self.isLoading = false;
          return;
        }
        if(response.data.messages[0].code != 0){
          this.$toast.open(response.data.messages[0].message);
          self.isLoading = false;
          return;
        }
        
        var record = response.data.response.data[0];
  
        // Set form data
        self.poData = record.fieldData;
        // console.log(record.fieldData['purchase_order__VENDOR__vendorID::salesContactCellPhone']);
        // // Set sales contact data
        // self.salesContact.name = record.fieldData['purchase_order__VENDOR__vendorID::salesContactNameFirst'] + " " + record.fieldData['purchase_order__VENDOR__vendorID::salesContactNameLast'];
        // self.salesContact.email = record.fieldData['purchase_order__VENDOR__vendorID::salesContactEmail'];
        // self.salesContact.cell = record.fieldData['purchase_order__VENDOR__vendorID::salesContactCellPhone'];
        // self.salesContact.phone = record.fieldData['purchase_order__VENDOR__vendorID::salesContactPhone'];
        // self.salesContact.fax = record.fieldData['purchase_order__VENDOR__vendorID::salesContactFax'];
        // console.log("In Received");
        // console.log(self.salesContact);
        
        var parts = self.poData.orderDate.split("/");
        var dt = new Date(
            parseInt(parts[2]),
            parseInt(parts[0])-1,
            parseInt(parts[1])
          );
        poForm.setDate(dt);
          
        var lineItemsPortal = record.portalData['PORTAL:PurchaseOrderItems']; 
        lineItemsPortal.forEach(function(row){ 
          self.lineData.push(row);
        });

        var documentsPortal = record.portalData['PORTAL:Documents'];
        documentsPortal.forEach(function(row){
          row.showDoc = false;
          self.documents.push(row);
        });
        
        // console.log({
        //   editing: this.editing,
        //   poData: self.poData,
        //   recValue: self.poData.isReceived,
        //   isReceived: !(self.poData.isReceived == 1)
        // })
        self.isLoading = false;
      })
      .catch( error => {
        if (error.response) {
          this.$toast.open(error.response.status);
        } 
        else {
          this.$toast.open("Unknown Error");
        }
      });
    },
    
    // Writes purchase order changes back to FM
    updateRecord: function(receivedOverride){
      var validForm = this.$refs.poForm.validate();
      var validLines = true;
      var validVendor = this.$refs.poForm.validateVendor();
      
      if(this.$refs.poItems.itemsInOrder){
        validLines = this.$refs.poItems.validate();
      }
      if(validForm == false || validLines.valid == false ){
          console.log("Form or lines not valid")
          return;
      }
      if(validLines.trackingNumberValid == false){
        console.log("Tracking number not valid")
        return
      }
 
      if(receivedOverride && this.poData.notes == ""){
        this.notification = true;
        return;
      }
      if(validVendor == false){
          this.$toast.open({
                    duration: 5000,
                    message: 'Please fill in a valid vendor.',
                    position: 'is-bottom',
                    type: 'is-primary'
          });
          return;
      }
      
      var compiledData = {
        poData: this.poData,
        // salesContact: this.salesContactLookup[this.poData.vendorName],
          // salesContactFirst: this.salesContactLookup[this.poData.vendorName].split(" ")[0],
          // salesContactLast: this.salesContactLookup[this.poData.vendorName].split(" ")[1],
        lineData: this.lineData,
        removedLineData: this.removedLineData,
        isReceived: receivedOverride ? '1' : (this.isReceivedAll ? '1' : '0'),
        isReceivedPartially: this.isReceivedPartially,
        includesPlanerDepartment: this.includesPlanerDepartment,
        receivedBy: this.editing ? "" : this.userInfo.employeeName
      };
      // Add in sales contact if it's not empty
      if(this.salesContact.name){
        compiledData.salesContactFirst = this.salesContact.name.split(" ")[0];
        compiledData.salesContactLast = this.salesContact.name.split(" ")[1];
      }
      compiledData.salesContactPhone = this.salesContact.phone;
      compiledData.salesContactCell = this.salesContact.cell;
      compiledData.salesContactFax = this.salesContact.fax
      compiledData.salesContactEmail = this.salesContact.email;
      
      var self = this;
      self.isLoading = true;
      var url = 'api/v2/runScript.php?layout=POST&script=POST-UpdateOrCreatePurchaseOrder';
      this.$http.post(url, compiledData)
      .then( response => {
        if(response.data.messages[0].code === "401"){
          self.$toast.open(response.data.messages[0].message);
          return;
        }
        if(response.data.messages[0].code  != 0){
          self.$toast.open(response.data.messages[0].message);
          return;
        }
        // Update PO number on web
        if(self.includesPlanerDepartment && self.poData.poNumber[0] != 'P' ){
          self.poData.poNumber = "P" + self.poData.poNumber;
        }
        else if(!self.includesPlanerDepartment && self.poData.poNumber[0] == 'P'){
          self.poData.poNumber = self.poData.poNumber.substring(1);
        }

        self.$toast.open({
                  duration: 5000,
                  message: 'Updated successfully',
                  position: 'is-bottom',
                  type: 'is-success'
        });
        console.log("Done updating record");
      }).catch( error => {
        if (error.response) {
          self.$toast.open(error.response.status);
        } 
        else {
          self.$toast.open("Unknown Error");
        }
      }).finally(()=>{
        console.log("Loading Data");
        self.loadValueLists();
        self.loadData();
      });
    },
    
    // Returns a unique set of an array
    uniqueDescriptions: function(array){
      var temp = {};
      for(var i =0; i < array.length; i++){
        temp[array[i]] = true;
      }
      return Object.keys(temp);
    },
    
    // Loads value lists for Departmeny, Vendors, and Description value lists
    loadValueLists: function(){
      self = this;
      this.$http.get('api/v2/getValueList.php')
      .then( response => {
        if(response.data.messages[0].code === "401"){
          self.$toast.open(response.data.messages[0].message);
          return;
        }
        if(response.data.messages[0].code != 0){
          self.$toast.open(response.data.messages[0].message);
          return;
        }
        self.vendorOptions = [];
        
        var departmentData = [];
        var vendorData = [];
        var lineItemDescriptionData = [];
        var trackingNumberData = [];
        var salesContactLookup = {};
        
        var departmentPortal = response.data.response.data[0].portalData['PORTAL-Department-Active'];
        var vendorPortal = response.data.response.data[0].portalData['PORTAL-Vendor-Active'];
        var lineItemDescriptionPortal = response.data.response.data[0].portalData['PORTAL-LineItem'];
        var trackingNumberPortal = response.data.response.data[0].portalData['PORTAL-Tracking-Active'];
        var trackingNumberOptions = [];
        
        // Push data to arrays
        departmentPortal.forEach(function(row){ 
          departmentData.push(row);
        });
        trackingNumberPortal.forEach(function(row){ 
          trackingNumberData.push(row);
        });
        trackingNumberData.forEach(function(trackingNumber){
          trackingNumberOptions.push(trackingNumber['menu__FINANCE_TRACKING_NUMBER__isActive__srt::name']);
        });
        vendorPortal.forEach(function(row){ 
          self.vendorOptions.push(row['menu__VENDOR__isActive__srt::vendorName']);
          vendorData.push(row);
          // Build a dictionary to find the sales contact
            salesContactLookup[row['menu__VENDOR__isActive__srt::vendorName'].toLowerCase()] = {
              'name': row['menu__VENDOR__isActive__srt::zctSalesContactFullName'],
              'cell': row['menu__VENDOR__isActive__srt::salesContactCellPhone'],
              'email': row['menu__VENDOR__isActive__srt::salesContactEmail'],
              'fax': row['menu__VENDOR__isActive__srt::salesContactFax'],
              'phone': row['menu__VENDOR__isActive__srt::salesContactPhone']
            }
        });
        
        lineItemDescriptionPortal.forEach(function(row){
          lineItemDescriptionData.push(row[DESCRIPTION]);
        });
        lineItemDescriptionData = self.uniqueDescriptions(lineItemDescriptionData);
        // Save to store
        store.commit('updateSalesContactLookup', salesContactLookup);
        store.commit('updateDepartmentValueList', departmentData);
        store.commit('updateVendorValueList', vendorData);
        store.commit('updateLineItemDescriptionValueList', lineItemDescriptionData);
        store.commit('updateTrackingNumberValueList', trackingNumberData);
        store.commit('updateTrackingNumberOptions', trackingNumberOptions);
      })
      .catch( error => {
        if (error.response) {
          self.$toast.open(error.response.status);
        } 
        else {
          self.$toast.open("Unknown Error");
        }
      });
    },
    // Cancels the editing of a purchase order and returns to the dashboard
    cancel: function(){
      this.$router.push({name: 'DashboardPage'});
    },
    
    // Brings up the print dialogue window, can save to pdf from there
    printPage: function(){
      window.print();
    },
    
    // Picks up emit from child and removes the chosen line item
    removeLineItem: function(lineItem){
      // Add the removed item to the removed item array if not a null item
      var itemToRemove = this.lineData.find(function(i){
        return i.recordId == lineItem.recordId;
      });
      if(itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description'] != null ||
         itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty']         != null ||
         itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::price']       != null ||
         itemToRemove['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::pricePer']    != null){
        this.removedLineData.push(itemToRemove);
      }
      
      // Remove the item from the line item array
      this.lineData = this.lineData.filter(function(i){
        if(i.recordId != lineItem.recordId) return true;
        else return false;
        });
    },
    
    // Opens uploader card window
    openUploader: function(){
      this.dropFiles = [];
      this.isComponentModalActive = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @media screen{
    .level h1{
      font-family: 'Poppins', sans-serif;
      font-size: 2rem;
      font-weight: 600;
      }
    h2{
      font-family: 'Poppins', sans-serif;
      font-size: 1rem;
      font-weight: 600;
      font-style: italic
      }
    .level{
      margin-bottom: 0px;
    }
    .well{
      margin-left: 30px;
      margin-right: 30px;
      margin-bottom: 15px;
    }
    .button-bar{
      margin-top: 15px;
    }
  }
  @media print{
    h1{
      font-family: 'Poppins', sans-serif;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0px !important;
      padding-bottom: 0px !important;
      }
    h2{
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      font-style: italic;
      margin: 0px 0px 15px 0px !important;
      padding: 0px !important;
      }
    @page { size: landscape; }
  
  }
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderReceivePage.vue